import { jsx } from 'react/jsx-runtime';
import { SvgIcon } from '../../SvgIcon/SvgIcon/index.js';

const IconBackground = SvgIcon({
    // eslint-disable-next-line max-len
    children: jsx("path", { d: "M1.992 6.5c0-1.11.39-2.055 1.172-2.836C3.945 2.883 4.891 2.492 6 2.492V6.5H1.992zm8.016 0H6v4.008H1.992v3.984H6V18.5H1.992c0 1.11.39 2.055 1.172 2.836.781.781 1.727 1.172 2.836 1.172V18.5h4.008v4.008h3.984V18.5H18v4.008c1.11 0 2.055-.39 2.836-1.172.781-.781 1.172-1.727 1.172-2.836H18v-4.008h4.008v-3.984H18V6.5h4.008c0-1.11-.39-2.055-1.172-2.836-.781-.781-1.727-1.172-2.836-1.172V6.5h-4.008V2.492h-3.984V6.5zm0 4.008V6.5h3.984v4.008h-3.984zm0 3.984H6v-3.984h4.008v3.984zm3.984 0v-3.984H18v3.984h-4.008zm0 0V18.5h-3.984v-4.008h3.984z" }),
});

export { IconBackground };
